/* eslint-disable react/no-danger */
/* eslint-disable react/forbid-prop-types */
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import renderFromString from "../../utils/handlebars";
import * as communicationActions from "../../redux/actions/communicationActions";

const mapDispatchToProps = {
  ...communicationActions,
};

const mapStateToProps = (state) => {
  const { workflows } = state;

  return {
    stateWorkflow: workflows,
  };
};

function PreviewTabTriggerEmail({ smartFields, stateWorkflow, event }) {
  const eventWorkFlow = stateWorkflow[event];

  const workflow = eventWorkFlow.blocks.find(
    (b) => b.id === stateWorkflow.activeWorkflowId,
  );

  const content = workflow.content.replace(/href/g, "");

  return (
    <div>
      <div className="pp_trigger_preview_panel_block">
        <span className="pp_trigger_preview_panel_block_title">Subject</span>
        <div className="pp_trigger_preview_panel_block_content">
          {renderFromString(workflow.subject, smartFields)}
        </div>
      </div>
      <div className="pp_trigger_preview_panel_block">
        <span className="pp_trigger_preview_panel_block_title">Message</span>
        <div
          dangerouslySetInnerHTML={{
            __html: renderFromString(content, smartFields),
          }}
          className="pp_trigger_preview_panel_block_content"
        />
      </div>
    </div>
  );
}

/*
 * PropType validation
 */
PreviewTabTriggerEmail.propTypes = {
  event: PropTypes.string.isRequired,
  stateWorkflow: PropTypes.object.isRequired,
  smartFields: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PreviewTabTriggerEmail);
